import { Breadcrumbs } from "components/breadcrumbs"
import { CreateEventAddonForm } from "./components"

export const CreateEventAddon: React.FC = () => {
  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create Event Addon" />
      <CreateEventAddonForm />
    </div>
  )
}
